import { Card as CardComponent } from './Card';
import { Footer } from './Footer';
import { FunctionBadge } from './FunctionBadge';
import { Header } from './Header';
import { Image } from './Image';
export const Card = CardComponent;
Card.Header = Header;
Card.Footer = Footer;
Card.Image = Image;
Card.FunctionBadge = FunctionBadge;
